import React from 'react';
import { motion } from 'framer-motion';
import UserAvatar from '../ui/UserAvatar';

function getInitials(name = '') {
  return (
    name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() || '')
      .join('') || '?'
  );
}

function NetworkMemberCard({
  name,
  avatarUrl,
  joinedLabel = '',
  stateLabel,
  referralsLabel,
  onClick,
}) {
  const className =
    'flex w-[176px] shrink-0 snap-start flex-col items-center rounded-2xl border border-secondary-200/80 bg-white px-4 py-5 text-center shadow-soft transition-shadow hover:shadow-medium  ';

  const body = (
    <>
      {avatarUrl ? (
        <UserAvatar src={avatarUrl} alt={name} size="round" variant="brand" />
      ) : (
        <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-orange-500 to-amber-500 text-lg font-bold text-white shadow-soft">
          {getInitials(name)}
        </div>
      )}
      <p className="mt-3 w-full truncate text-sm font-semibold text-secondary-900 ">
        {name}
      </p>
      {joinedLabel ? (
        <p className="w-full truncate text-[11px] text-secondary-500 ">{joinedLabel}</p>
      ) : null}
      <span className="mt-2.5 rounded-full bg-orange-50 px-2.5 py-0.5 text-[10px] font-semibold text-orange-700  ">
        {stateLabel}
      </span>
      <span className="mt-1.5 text-[10px] font-medium text-secondary-500 ">
        {referralsLabel}
      </span>
    </>
  );

  if (onClick) {
    return (
      <motion.button
        type="button"
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        onClick={onClick}
        className={className}
      >
        {body}
      </motion.button>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      className={className}
    >
      {body}
    </motion.div>
  );
}

export default NetworkMemberCard;
